//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'select-coupon-modal',
    props: {
        onSelected: Function,
        channelType: {
            type: Number,
            required: true
        }
    },
    data() {
        var vm = this;
        return {
            loading: false,
            searchInput: {
                status: 2
            },
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '名称',
                    key: 'name',
                    align: 'center'
                },
                // {
                //     title: '状态',
                //     key: 'statusStr',
                //     align: 'center'
                // },
                {
                    title: '类型',
                    key: 'typeStr',
                    align: 'center'
                },
                {
                    title: '面值（折扣）',
                    key: 'faceValue',
                    align: 'center'
                },
                {
                    title: '总数',
                    key: 'quantity',
                    align: 'center'
                },
                {
                    title: '生效日期',
                    render: (h, params) => {
                        return h('span', new Date(params.row.startTime).toLocaleDateString());
                    },
                    align: 'center'
                },
                {
                    title: '截止日期',
                    render: (h, params) => {
                        return h('span', new Date(params.row.endTime).toLocaleDateString());
                    },
                    align: 'center'
                },
                {
                    key: 'actions',
                    title: '操作',
                    width: 100,
                    align: 'center',
                    render(h, params) {
                        return h('Button', {
                            props: {
                                size: 'small',
                                type: 'primary'
                            },
                            on: {
                                click() {
                                    if (vm.onSelected !== undefined) {
                                        vm.onSelected(params.row);
                                    }
                                }
                            }
                        }, '选择');
                    }
                }
                // {
                //     title: '创建日期',
                //     render: (h, params) => {
                //         return h('span', new Date(params.row.creationTime).toLocaleDateString());
                //     },
                //     align: 'center'
                // },
                // {
                //     title: '操作',
                //     align: 'center',
                //     render: (h, params) => {
                //         const row = params.row;
                //         const actions = [];
                //
                //         var del = h('Button', {
                //             props: {
                //                 type: 'error',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.delCoupon(params.row);
                //                 }
                //             }
                //         }, '删除');
                //
                //         var edit = h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.editCoupon(params.row);
                //                 }
                //             }
                //         }, '编辑');
                //
                //         var submit = h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.onSubmit(params.row);
                //                 }
                //             }
                //         }, '提交审核');
                //
                //         var approve = h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.onApprove(params.row);
                //                 }
                //             }
                //         }, '发布');
                //
                //         if (row.status == 0) {
                //             actions.push(submit);
                //             actions.push(edit);
                //             actions.push(del);
                //         }
                //         if (row.status == 1) {
                //             actions.push(approve);
                //
                //         }
                //
                //         return h('div', actions);
                //     }
                // }
            ],
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            list: [],
            searchInput: {}
        };
    },
    computed: {
        // currentPage() {
        //     return this.$store.state.coupon.currentPage;
        // },
        // totalCount() {
        //     return this.$store.state.coupon.totalCount;
        // },
        // pageSize() {
        //     return this.$store.state.coupon.pageSize;
        // },
        // list() {
        //     return this.$store.state.coupon.list;
        // }
    },
    methods: {
        pageChange(page) {
            // this.$store.commit('coupon/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('coupon/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            let page = {
                channelType: this.channelType,
                status: 2,
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            await abp.ajax.post('/api/services/app/Coupon/Search', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        }
    },
    created() {
        this.getPage();
    },
    watch: {
        channelType() {
            this.currentPage = 1;
            this.getPage();
        }
    }
};
